import React, { createContext, useContext, useEffect, useState } from 'react'
import faceIO from '@faceio/fiojs'

const FaceIOContext = createContext(null)

export const FaceIOProvider = ({ children }) => {
    const [faceioInstance, setFaceioInstance] = useState(null)
    const [error, setError] = useState(null)
    const initRef = React.useRef(false)

    useEffect(() => {
        if (initRef.current) return
        initRef.current = true

        const initFaceIO = async () => {
            try {
                const instance = new faceIO(import.meta.env.VITE_FACEIO_APP_ID)
                setFaceioInstance(instance)
            } catch (err) {
                console.error('Failed to initialize FaceIO:', err)
                setError(err.message)
                // Reset ref on error to allow retry if component remounts cleanly
                initRef.current = false
            }
        }

        initFaceIO()
    }, [])

    return (
        <FaceIOContext.Provider value={{ faceioInstance, error }}>
            {children}
        </FaceIOContext.Provider>
    )
}

export const useFaceIO = () => {
    const context = useContext(FaceIOContext)
    if (!context) {
        throw new Error('useFaceIO must be used within a FaceIOProvider')
    }
    return context
}
